import { Directive, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';

@Directive({ selector: '[nimbusCopyClipboard]', standalone: false })
export class CopyClipboardDirective {
  @Input('nimbusCopyClipboard') public payload: string;
  @Output() public copied: EventEmitter<string> = new EventEmitter<string>();

  public constructor(private readonly clipboard: Clipboard) {}

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    event.preventDefault();
    if (!this.payload) {
      return;
    }

    if (this.clipboard.copy(this.payload)) {
      this.copied.emit(this.payload);
    }
  }
}
